import { useSearchParams } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'
import { VendorPeople, type InvitePrefill } from '@/components/VendorPeople'

/**
 * A vendor's own people, for everyone at the vendor to see and its owners to
 * manage: a planner and their assistant, a rental company's staff. Opened from
 * a "wants to join" email (`?invite=<email>&name=<name>`), the invite form is
 * open with them filled in.
 */
export function VendorPeoplePage() {
  const { user } = useAuth()
  const [params] = useSearchParams()
  const inviteEmail = params.get('invite')
  const prefill: InvitePrefill | undefined = inviteEmail === null ? undefined : { email: inviteEmail, name: params.get('name') ?? '' }

  return (
    <PageContainer width="wide" className="space-y-6">
      <PageHeader title="People" description="Everyone who can sign in as your company. Owners invite and remove people." />
      <VendorPeople scope={{ kind: 'own' }} currentUserId={user?.id ?? null} prefill={prefill} />
    </PageContainer>
  )
}
